import React from 'react';
import { browserHistory } from 'react-router';
import ParentAuthPage from './ParentAuthPage';
import ViewSpinner from 'components/ViewSpinner';
import { ViewNumberInput } from 'components/ViewInput';
import UserService from '../utils/UserService';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from 'actions/AuthActions';
import * as UiActions from 'actions/UiActions';
import { setBonus as SetBonus } from 'actions/BonusActions';
import classNames from 'classnames';
import 'css/PayoutPage.css';
import Button from 'ui/Button';
import { detectMobile, formatDenmarkCurrency } from 'utils/UiHelper';
import { NotificationManager } from 'react-notifications';
import { ActiveBonuses } from '@it25syv/25syv-ui';
import Text from '../ui/Text';
import BonusService from '../utils/BonusService';

class PaymentPayoutPage extends ParentAuthPage {
    constructor() {
        super();

        this.state = {
            ...this.state,
            error: null,
            success: false,
            payout: null,
            money: '',
            pending: false,
        };
    }

    getAmount() {
        UserService.MoneyPayout().then((res) => {
            if (!res.data || res.errorMessage) {
                let msg = res.errorMessage;

                if (
                    this.props.auth.user &&
                    this.props.auth.user.status === 'temp'
                ) {
                    msg =
                        'Du kan ikke udbetale fordi din konto stadig kun er midlertidig. Da vi ikke har kunnet verificere din konto igennem NEMID, skal vi bede dig indsende et digitalt foto af dit gyldige sygesikringsbevis. Dette skal sendes til support@bet25.dk';
                }

                this.setState({
                    error: {
                        code: res.statusCode,
                        msg: msg,
                        show: true,
                    },
                });
            } else {
                if (
                    res.data.amount === 0 &&
                    this.props.auth.user &&
                    this.props.auth.user.status === 'temp'
                ) {
                    this.setState({
                        error: {
                            code: res.statusCode,
                            msg:
                                'Du kan ikke udbetale fordi din konto stadig kun er midlertidig. Da vi ikke har kunnet verificere din konto igennem NEMID, skal vi bede dig indsende et digitalt foto af dit gyldige sygesikringsbevis. Dette skal sendes til support@bet25.dk',
                            show: true,
                        },
                    });
                } else {
                    const payout = res.data;

                    this.setState({
                        payout: {
                            ...payout,
                            voucher: payout.pending - payout.bonus,
                        },
                    });
                }
            }
        });
    }

    makePayout(howmuch) {
        let amount = howmuch;
        amount = parseFloat(amount);
        this.setState({ pending: true });

        if (amount < 100) {
            this.setState({
                error: {
                    msg: 'Mindste udbetaling er 100 kr.',
                    show: true,
                },
            });
            this.setState({ pending: false });

            return;
        }

        UserService.MoneyWithdraw(amount)
            .then((res) => {
                this.successPayoutHandler(res);
                this.setState({ pending: false });
            })
            .catch((err) => {
                this.failedPayoutHandler(err);
                this.setState({ pending: false });
            });
    }

    successPayoutHandler = (res) => {
        if (!res.success) {
            this.failedPayoutHandler(res);
            return;
        }
        this.setState({
            success: true,
            error: false,
        });
        NotificationManager.success(
            'Udbetalingen overføres automatisk til din NemKonto inden for 1-2 bankdage.'
        );
        this.props.authActions.updateBalance();
        browserHistory.push('/sport/');
        this.props.uiActions.hideModal('USER_MENU');
    };

    failedPayoutHandler = (res) => {
        this.setState({
            success: false,
            error: {
                msg: res.errorMessage,
                show: true,
            },
        });
    };

    componentDidMount() {
        this.setPageTitle('Udbetaling');

        this.getAmount();

        BonusService.getActiveBonus().then((res) => {
            let data = res?.data;
            if (data) {
                this.props.setBonus(data);
            }
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setTimeout(() => {
            if (!this.props.auth.user) {
                browserHistory.push('/sport/');
                this.props.uiActions.showModal('LOGIN_FIRST');
            }
        }, 500);
    }

    valueHandler(name, val) {
        this.setState({ money: val });
    }

    onClickHandler() {
        this.makePayout(
            this.state.money.includes(',')
                ? this.state.money.replace(',', '.')
                : this.state.money
        );
    }

    setAmount(amount) {
        this.setState({ money: amount });
    }

    removeBonus() {
        this.props.uiActions.showModal('REMOVE_BONUS_CONFIRM_MODAL');
    }

    getView() {
        const payout = this.state.payout;

        const errorMsg = this.state.error && (
            <Text size={'12'} color={'red'} align={'center'}>
                {this.state.error.msg}
            </Text>
        );

        let view = null;
        if (this.props.bonus?.bonusType) {
            view = (
                <div className={'active-bonus-wrapper'}>
                    {!detectMobile() && (
                        <Text
                            size={'22'}
                            align={'center'}
                            weight={'bold'}
                            color={'#000'}
                            margin={'0 0 15px'}
                        >
                            Udbetaling
                        </Text>
                    )}
                    <ActiveBonuses
                        onRemove={this.removeBonus.bind(this)}
                        activeBonus={this.props.bonus.amount}
                        rollover={this.props.bonus.rollOver}
                        initialRollover={this.props.bonus.initRollOver}
                        gameId={this.props.bonus.gameId}
                        bonusButtonText={'Gå til Bet25 Casino'}
                    />
                </div>
            );
        } else if (payout && payout.rollover > 0) {
            view = (
                <div className="info">
                    <span>
                        Din saldo er {payout.amount}
                        kr. inkluderet en bonus på {payout.bonus}
                        kr.
                    </span>
                    {payout.voucher ? (
                        <span>
                            inkluderet en voucher på {payout.voucher}
                            kr.
                        </span>
                    ) : null}
                    <br />
                    <span>
                        Før du kan foretage en udbetaling skal du omsætte for
                        mindst {payout.rollover}
                        kr. til minimum odds{' '}
                        {payout.minOdds === 0
                            ? '1.95'
                            : payout.minOdds.toFixed(2)}
                    </span>
                </div>
            );
        } else {
            if (payout && payout.remainingCashinWageringAmount > 0) {
                view = (
                    <div className="info">
                        <span>
                            Du har en aktiv bonus på {payout.totalBonus}
                            kr, og du mangler at omsætte før{' '}
                            {payout.remainingCashinWageringAmount}
                            kr på Bet25 Sport, før at du kan foretage en
                            udbetaling.
                        </span>
                    </div>
                );
            } else {
                view = (
                    <div>
                        <div className="info">
                            Beløbet bliver udbetalt til din nemkonto. Der kan gå
                            mellem 1-2 bankdage før pengene er på din konto.
                            <br />
                            <br />
                            Du kan max udbetale: &nbsp;
                            {payout ? payout.amount : 0} kr.
                            <br />
                            Mindste udbetaling er 100 kr.
                            <br />
                            <br />
                            <div className="user-saldo">
                                Din saldo:{' '}
                                {formatDenmarkCurrency(
                                    this.props?.auth?.user?.balance
                                ) +
                                    ' ' +
                                    this.props?.auth?.user?.currency}
                            </div>
                        </div>

                        <ViewNumberInput
                            withoutLabel="yes"
                            placeholder="Indtast beløb"
                            icon="pancil"
                            name="amount"
                            type={'text'}
                            autoComplete={'off'}
                            pattern="[0-9]+([\.][0-9]{1,2})?"
                            valueHandler={this.valueHandler.bind(this)}
                            value={this.state.money}
                        />
                        <div>{!this.state.money}</div>
                        <Button
                            margin="0 auto"
                            width="200px"
                            disabled={!this.state.money || this.state.pending}
                            active={!!this.state.money}
                            onClick={this.onClickHandler.bind(this)}
                        >
                            Udbetal &nbsp;
                            {!this.state.money
                                ? null
                                : `${
                                      this.state.money.includes('.')
                                          ? this.state.money.replace('.', ',')
                                          : this.state.money
                                  } DKK`}
                        </Button>
                    </div>
                );
            }
        }

        return (
            <section>
                {view}
                {errorMsg}
            </section>
        );
    }

    render() {
        const viewSpinner = <ViewSpinner />;

        return (
            <div
                className={classNames('payment-deposit-page', {
                    mobile: detectMobile(),
                })}
            >
                {this.props.auth.user &&
                this.props.auth.user.status === 'temp' ? (
                    <div className="red p10 text-center">
                        <h3>OBS!</h3>
                        <p>
                            Vi mangler at få verificeret din konto. Da din konto
                            ikke blev automatisk verificeret, skal vi bede dig
                            indsende et foto af dit gule sundhedskort til{' '}
                            <a href="mailto:dokument@bet25.dk">
                                dokument@bet25.dk
                            </a>
                            . Ellers lukkes din konto efter 30 dage.
                        </p>
                    </div>
                ) : (
                    <div>
                        {this.getHeaderView(() => {
                            this.props.uiActions.showModal('USER_MENU');
                        })}

                        {this.state.payout || this.state.error
                            ? this.getView()
                            : viewSpinner}
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, bonus: state.bonus };
}

function mapDispatchToProps(dispatch) {
    return {
        authActions: bindActionCreators(AuthActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
        setBonus: bindActionCreators(SetBonus, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentPayoutPage);
